import { getRequest, getRequestBlob } from "../../../../api/client";
import { getTrashSinglePdfApi } from "../../../../Endpoints";
import { TrashScheduleQueryParams } from "../../table/api/getTrashSchedule";

export const getSinglePdf = async ({ id }: TrashScheduleQueryParams) => {
  const url = (await getRequest<{ url: string }>(`${getTrashSinglePdfApi(id)}`))
    .url;

  return getRequestBlob("", url);
};
